<template>
  <div v-if="order.actions">
    <v-sheet class="pt-1 transparent-background-color d-inline-block">
      <v-tooltip
        top
        v-if="showView && $permission.permissionAllow('ReturnOrders', 'view')"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="info"
            class="px-2 me-2 mb-1"
            :href="($route.path.startsWith('/return-orders-approve')
                ? '/#/return-orders-approve/'
                : '/#/return-orders/')  + order.id"
          >
            <v-icon x-small class="pe-1">fa-align-left</v-icon>
            {{ $t("Opt.details") }}
          </v-btn>
        </template>
        <span>{{ $t("CRUD.viewInfo", [$t("ReturnOrder.ObjectName")]) }}</span>
      </v-tooltip>
      <v-tooltip
        top
        v-if="
          showEdit &&
          order.actions &&
          order.actions.account_edit &&
          $permission.permissionAllow('ReturnOrders', 'edit')
        "
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="primary"
            class="px-2 me-2 mb-1"
            @click.stop="
              $permission.checkAccountExpired().then(() => {
                detailMode
                  ? $emit('edit')
                  : $router.push('/return-orders/' + order.id + '/edit');
              })
            "
          >
            <v-icon x-small class="pe-1">fa-pencil-alt</v-icon>
            {{ $t("ReturnOrder.actions.edit") }}
          </v-btn>
        </template>
        <span>{{ $t("ReturnOrder.actions.editOrder") }}</span>
      </v-tooltip>
      <v-tooltip
        top
        v-if="
          showConfirm &&
          order.actions &&
          order.actions.confirm &&
          $permission.permissionAllow('ReturnOrders', 'confirm')
        "
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="action"
            class="px-2 me-2 mb-1"
            @click.stop="
              $permission.checkAccountExpired().then(() => {
                detailMode
                  ? $emit('confirm')
                  : $router.push('/return-orders/' + order.id + '/confirm');
              })
            "
          >
            <v-icon x-small class="pe-1">fa-location-arrow</v-icon>
            {{ $t("ReturnOrder.actions.confirm") }}
          </v-btn>
        </template>
        <span>{{ $t("ReturnOrder.actions.confirmOrder") }}</span>
      </v-tooltip>
      <v-tooltip
        top
        v-if="
          showRedeliver &&
          order.actions &&
          order.actions.redeliver &&
          $permission.permissionAllow('ReturnOrders', 'redeliver')
        "
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="action"
            class="px-2 me-2 mb-1"
            @click.stop="doAction('redeliver')"
          >
            <v-icon x-small class="pe-1">fa-location-arrow</v-icon>
            {{ $t("ReturnOrder.actions.redeliver") }}
          </v-btn>
        </template>
        <span>{{ $t("ReturnOrder.actions.redeliverOrder") }}</span>
      </v-tooltip>
      <v-tooltip
        top
        v-if="
          showApprove &&
          order.actions &&
          order.actions.approve &&
          $permission.permissionAllow('ReturnOrders', 'approve')
        "
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="action"
            class="px-2 me-2 mb-1"
            @click.stop="doAction('approve')"
          >
            <v-icon x-small class="pe-1">fa-stamp</v-icon>
            {{
              $t(
                detailMode
                  ? "ReturnOrder.actions.approveInDetail"
                  : "ReturnOrder.actions.approve"
              )
            }}
          </v-btn>
        </template>
        <span>{{ $t("ReturnOrder.actions.approveOrder") }}</span>
      </v-tooltip>
      <v-tooltip
        top
        v-if="
          showCancel &&
          order.actions &&
          order.actions.cancel &&
          $permission.permissionAllow('ReturnOrders', 'cancel')
        "
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="danger"
            class="px-2 me-2 mb-1"
            @click.stop="cancelAlert = true"
          >
            <v-icon x-small class="pe-1">fa-exclamation</v-icon>
            {{ $t("ReturnOrder.actions.cancel") }}
          </v-btn>
        </template>
        <span>{{ $t("ReturnOrder.actions.cancelOrder") }}</span>
      </v-tooltip>
      <v-tooltip
        top
        v-if="showPrint && $permission.permissionAllow('ReturnOrders', 'returnOrderPrint')"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="print"
            class="px-2 me-2 mb-1"
            :href="'/#/print/return-order-print/' + order.id"
          >
            <v-icon x-small class="pe-1">fa-print</v-icon>
            {{ $t("Print.print") }}
          </v-btn>
        </template>
        <span>{{ $t("ReturnOrder.actions.returnOrderPrint") }}</span>
      </v-tooltip>
      <!-- 导出退货单 -->
      <v-tooltip
        top
        v-if="showExport && $permission.permissionAllow('ReturnOrders', 'export')"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="print"
            class="px-2 me-2 mb-1"
            @click.stop="toExport()"
          >
            <v-icon x-small class="pe-1">fa-file-excel</v-icon>
            {{ $t("ReturnOrder.actions.export") }}
          </v-btn>
        </template>
        <span>{{ $t("ReturnOrder.actions.export") }}</span>
      </v-tooltip>
    </v-sheet>
    <DialogDelete
      v-model="cancelAlert"
      cancel-mode
      :label="$t('ReturnOrder.ObjectName')"
      :code="order.order_code"
      @confirm="doAction('cancel')"
    />
  </div>
</template>

<script>
import DialogDelete from "@/components/plugins/DialogDelete";
import ReturnOrders from "@/api/return_orders";

export default {
  name: "OrderActions",

  components: {
    DialogDelete,
  },

  props: {
    order: Object,
    detailMode: Boolean,
    showView: Boolean,
    showEdit: Boolean,
    showConfirm: Boolean,
    showRedeliver: Boolean,
    showApprove: Boolean,
    showCancel: Boolean,
    showPrint: Boolean,
    showExport: Boolean,
  },

  computed: {},

  data: () => ({
    printBtnMenu: false,
    cancelAlert: false,
  }),

  methods: {
    actionMethod(mode) {
      if (mode == "redeliver") return ReturnOrders.redeliver(this.order.id);
      else if (mode == "approve") return ReturnOrders.approve(this.order.id);
      else if (mode == "cancel") return ReturnOrders.cancel(this.order.id);
    },
    doAction(mode) {
      this.$permission.checkAccountExpired().then(
        function () {
          this.actionMethod(mode).then(
            function (response) {
              if (response.data.status.isOK()) {
                if (this.detailMode)
                  this.$router.push(
                    mode == "approve"
                      ? "/return-orders-approve"
                      : "/return-orders"
                  );
                this.$emit("done");
                this.$store.commit("refreshToDos", true);
              }
            }.bind(this)
          );
        }.bind(this)
      );
    },
    toExport() {
      ReturnOrders.detailExports(this.order.id);
    }
  },
};
</script>